import i18n from '@sparklayer-io/spark-dash-core/i18n';

function applyLanguage(lng: string) {
  document.documentElement.lang = lng;
  document.documentElement.dir = i18n.dir(lng);
}

/**
 * Keeps `lang` and `dir` on `<html>` in step with the active language, so the logical properties
 * and `rtl:` variants flip the layout for a right-to-left locale. Portalled menus and dialogs sit
 * outside the app root, which is why it is the document and not a wrapper.
 */
export function syncDocumentLanguage() {
  if (i18n.language) {
    applyLanguage(i18n.language);
  }
  i18n.on('languageChanged', applyLanguage);
}
